import Repository from "@/repository";

const defaultProject = {
  counterparty: null,
  name: "",
  started_at: "",
  ended_at: "",
  cost: "",
  readiness: "",
};

export default {
  state: {
    projects: [],
    project: JSON.parse(JSON.stringify(defaultProject)),
    totalPages: 1,
    thisPage: 1,
  },
  actions: {
    async getProjects({ commit }, params) {
      const data = {
        name: params.name,
        counterparty: params.counterparty,
        ordering: params.ordering,
        size: 20,
      };
      if (!params.isNotLoad) {
        commit("setIsLoader", true);
      }

      const { value, error } = await Repository.ProjectsActions.get(data);
      if (!error) {
        commit("setProjects", value.data);
        commit("setTotalPages", value.total_pages);
        commit("setThisPage", value.page);
      }
      commit("setIsLoader", false);
    },
    async getProject({ commit }, slug) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.ProjectsActions.getOne(
        slug
      );
      if (!error) {
        commit("setProject", value);
      }
      commit("setIsLoader", false);
    },
    async createProject({ commit, state }) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.ProjectsActions.create(
        state.project
      );
      if (error) {
        commit("setErrors", error);
        commit("setIsLoader", false);
        return false;
      }
      state.project.slug = value.slug;
      await Repository.ProjectsActions.update(state.project);
      commit("resetProject");
      commit("setIsLoader", false);
      return true;
    },
    async updateProject({ commit, state }) {
      commit("setIsLoader", true);
      const payload = JSON.parse(JSON.stringify(state.project));
      if (payload.counterparty.id) {
        payload.counterparty = payload.counterparty.id
      }

      const { error } = await Repository.ProjectsActions.update(
        payload
      );
      if (error) {
        commit("setErrors", error);
        commit("setIsLoader", false);
        return false;
      }
      commit("setIsLoader", false);
      return true;
    },
    async deleteProject({ commit }, slug) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.ProjectsActions.delete(
        slug
      );
      commit("setIsLoader", false);
    },
  },
  mutations: {
    setProjectsField(state, { field, value }) {
      if (field.split(".").length > 1) {
        if (
          !(field.split(".")[0] in state.project) ||
          state.project[field.split(".")[0]] === null
        ) {
          state.project[field.split(".")[0]] = {};
        }
        state.project[field.split(".")[0]][field.split(".")[1]] = value;
      } else {
        state.project[field] = value;
      }
    },
    setProjects(state, value) {
      state.projects = value;
    },
    setProject(state, value) {
      state.project = value;
    },
    resetProject(state) {
      state.project = JSON.parse(JSON.stringify(defaultProject));
    },
    setTotalPages(state, value) {
      state.totalPages = value;
    },
    setThisPage(state, value) {
      state.thisPage = value;
    },
  },
};
